// @ts-nocheck

import { fetchRequest, initialFetchListParams } from './index';
/**
 * Получение списка дней
 */
export const fetchBusinessDays = async (params = initialFetchListParams) => await fetchRequest.get('/businessDay', {
  ...initialFetchListParams,
  ...params
});

/**
 * Получение дня по идентификатору
 */
export const fetchBusinessDay = async (id, params = {}) => {
  const businessDay = await fetchRequest.get(`/businessDay/${id}`, params);
  if (businessDay) return businessDay;
  throw new Error('Не удалось день для производственного календаря');
};

/**
 * Удаление дня
 */
export const deleteBusinessDay = async id => {
  const deleted = await fetchRequest.delete(`/businessDay/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить день для производственного календаря');
};

/**
 * Обновление дня
 */
export const updateBusinessDay = async businessDay => {
  const updated = await fetchRequest.put('/businessDay', businessDay);
  if (updated) return updated;
  throw new Error('Не удалось обновить день для производственного календаря');
};

/**
 * Добавление дня
 */
export const addBusinessDay = async businessDay => {
  const added = await fetchRequest.post('/businessDay', businessDay);
  if (added) return added;
  throw new Error('Не удалось добавить день для производственного календаря');
};
export default {
  fetchBusinessDays,
  fetchBusinessDay,
  deleteBusinessDay,
  updateBusinessDay,
  addBusinessDay
};
